import * as React from 'react'
import FormattedContent from '@eversports/klimt-primitives/FormattedContent'
import styled from '@eversports/klimt-design-components/styled'
import ExpandableContent from '@eversports/klimt-patterns/ExpandableContent'

const SmallTextContent = styled('div')`
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.03125rem;

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.03125rem;
  }

  ul {
    list-style: inside;
    margin-left: 1.25rem;
    margin-bottom: 0.5rem;

    li {
      line-height: 1.5rem;
    }

    li > p {
      display: inline;
    }
  }

  strong,
  b {
    font-weight: bold;
  }

  i,
  em {
    font-style: italic;
  }
`

const MAX_DESCRIPTION_HEIGHT = 84

interface Props {
  description: string
}

const Description = ({ description }: Props) => (
  <ExpandableContent clampedTextHeight={MAX_DESCRIPTION_HEIGHT}>
    <FormattedContent htmlContent={description} WrapperComponent={SmallTextContent} />
  </ExpandableContent>
)

export default Description
